import { Box, Button, Paper, Stack } from '@mui/material';
import { DataGrid, GridColDef, GridToolbar } from '@mui/x-data-grid';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import RefreshOutlinedIcon from '@mui/icons-material/RefreshOutlined';
import { PageHeader } from 'src/ui/shell/PageHeader';
import { enterpriseDataGridSx } from 'src/ui/shell/enterpriseDataGridSx';

type TenantRow = {
  id: string;
  label: string;
  status: 'ACTIVE' | 'SUSPENDED';
  createdAt: string;
};

const columns: GridColDef<TenantRow>[] = [
  { field: 'label', headerName: 'Tenant', flex: 1, minWidth: 220 },
  {
    field: 'status',
    headerName: 'Status',
    width: 140,
    renderCell: ({ value }) => (
      <Box
        component="span"
        sx={{
          px: 1.25,
          py: 0.35,
          borderRadius: 99,
          fontSize: 11,
          fontWeight: 700,
          letterSpacing: 0.4,
          textTransform: 'uppercase',
          color: value === 'ACTIVE' ? 'success.light' : 'warning.light',
          bgcolor: value === 'ACTIVE' ? 'rgba(52,211,153,0.12)' : 'rgba(251,191,36,0.12)',
          border: `1px solid ${value === 'ACTIVE' ? 'rgba(52,211,153,0.35)' : 'rgba(251,191,36,0.35)'}`,
        }}
      >
        {value}
      </Box>
    ),
  },
  { field: 'createdAt', headerName: 'Created', width: 180 },
];

const rows: TenantRow[] = [
  { id: 'amn', label: 'amn', status: 'ACTIVE', createdAt: '2026-01-10' },
  { id: 'demo', label: 'demo', status: 'SUSPENDED', createdAt: '2026-02-05' },
  { id: 'acme', label: 'acme-corp', status: 'ACTIVE', createdAt: '2026-03-18' },
];

export function TenantsPage() {
  return (
    <Stack spacing={3}>
      <PageHeader
        eyebrow="Directory"
        title="Tenants"
        description="Every row is a trust boundary in x-IAM. Provision, suspend, and observe tenant health from one place."
        rightSlot={
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} width={{ xs: '100%', sm: 'auto' }}>
            <Button startIcon={<RefreshOutlinedIcon />} variant="outlined" color="inherit" disabled sx={{ fontWeight: 600 }}>
              Sync
            </Button>
            <Button startIcon={<AddOutlinedIcon />} variant="contained" disabled sx={{ fontWeight: 600 }}>
              Add tenant
            </Button>
          </Stack>
        }
      />

      <Paper
        sx={{
          p: 0,
          overflow: 'hidden',
          borderRadius: 2,
        }}
      >
        <Box sx={{ height: 540, width: '100%', p: 0 }}>
          <DataGrid
            rows={rows}
            columns={columns}
            disableRowSelectionOnClick
            slots={{ toolbar: GridToolbar }}
            slotProps={{
              toolbar: {
                showQuickFilter: true,
                quickFilterProps: { debounceMs: 250 },
              },
            }}
            pageSizeOptions={[10, 25, 50]}
            initialState={{
              pagination: { paginationModel: { pageSize: 10, page: 0 } },
            }}
            sx={enterpriseDataGridSx}
          />
        </Box>
      </Paper>
    </Stack>
  );
}
